import script from "./ModuleAccess.vue?vue&type=script&lang=js"
export * from "./ModuleAccess.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__